<template>
  <Teleport to="body">
    <!-- Overlay -->
    <div
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-[#050c28]/80 backdrop-blur-sm overflow-hidden"
    >
      <!-- Blob BG -->
      <div
        class="bg-[var(--brand)] absolute -top-24 -left-24 w-[400px] h-[400px] rounded-full opacity-20 blur-[80px] animate-pulse"
      ></div>
      <div
        class="absolute -bottom-20 -right-20 w-[350px] h-[350px] rounded-full bg-[#f8c300] opacity-15 blur-[80px] animate-pulse"
        style="animation-delay: 2s"
      ></div>

      <!-- Card -->
      <div
        class="relative z-10 flex w-[min(880px,95vw)] min-h-[500px] rounded-2xl overflow-hidden shadow-[0_40px_100px_rgba(0,0,0,0.5)] animate-[cardIn_0.5s_cubic-bezier(0.34,1.56,0.64,1)_both]"
      >
        <!-- ── Left Illustration Panel ── -->
        <!-- <div
          style="
            background: linear-gradient(
              to bottom right,
              #1a3499,
              var(--brandHoverText),
              #061245
            );
          "
          class="hidden md:flex flex-col items-center justify-center gap-6 flex-[0_0_42%] px-8 py-10 relative overflow-hidden"
        > -->
        <div
          class="hidden md:flex flex-col items-center justify-center gap-6 flex-[0_0_42%] bg-gradient-to-br from-[#1a3499] via-[#0f2377] to-[#061245] px-8 py-10 relative overflow-hidden"
        >
          <!-- dot grid texture -->
          <div
            class="absolute inset-0 opacity-[0.04]"
            style="
              background-image: radial-gradient(
                circle,
                #fff 1px,
                transparent 1px
              );
              background-size: 24px 24px;
            "
          ></div>

          <!-- Clock SVG -->
          <div class="relative z-10 flex flex-col items-center gap-5">
            <svg
              viewBox="0 0 220 220"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="w-44 h-44 drop-shadow-[0_20px_40px_rgba(248,195,0,0.25)] animate-pulse"
            >
              <circle
                cx="110"
                cy="110"
                r="100"
                fill="url(#glowG)"
                opacity="0.15"
              />
              <circle cx="110" cy="110" r="85" fill="url(#faceG)" />
              <circle
                cx="110"
                cy="110"
                r="85"
                stroke="url(#ringG)"
                stroke-width="3"
              />
              <line
                x1="110"
                y1="32"
                x2="110"
                y2="44"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                opacity="0.9"
              />
              <line
                x1="110"
                y1="176"
                x2="110"
                y2="188"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                opacity="0.9"
              />
              <line
                x1="32"
                y1="110"
                x2="44"
                y2="110"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                opacity="0.9"
              />
              <line
                x1="176"
                y1="110"
                x2="188"
                y2="110"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                opacity="0.9"
              />
              <line
                x1="155"
                y1="40"
                x2="150"
                y2="51"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                opacity="0.4"
              />
              <line
                x1="180"
                y1="65"
                x2="169"
                y2="70"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                opacity="0.4"
              />
              <line
                x1="180"
                y1="155"
                x2="169"
                y2="150"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                opacity="0.4"
              />
              <line
                x1="155"
                y1="180"
                x2="150"
                y2="169"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                opacity="0.4"
              />
              <line
                x1="65"
                y1="40"
                x2="70"
                y2="51"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                opacity="0.4"
              />
              <line
                x1="40"
                y1="65"
                x2="51"
                y2="70"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                opacity="0.4"
              />
              <line
                x1="40"
                y1="155"
                x2="51"
                y2="150"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                opacity="0.4"
              />
              <line
                x1="65"
                y1="180"
                x2="70"
                y2="169"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                opacity="0.4"
              />
              <!-- Hands -->
              <line
                x1="110"
                y1="110"
                x2="110"
                y2="68"
                stroke="white"
                stroke-width="4"
                stroke-linecap="round"
                style="
                  transform-origin: 110px 110px;
                  animation: rotateHour 43200s linear infinite;
                "
              />
              <line
                x1="110"
                y1="110"
                x2="142"
                y2="86"
                stroke="#f8c300"
                stroke-width="3"
                stroke-linecap="round"
                style="
                  transform-origin: 110px 110px;
                  animation: sweepMin 3s ease-in-out infinite;
                "
              />
              <circle cx="110" cy="110" r="6" fill="#f8c300" />
              <circle cx="110" cy="110" r="3" fill="white" />
              <circle cx="110" cy="166" r="14" fill="#f8c300" opacity="0.95" />
              <text
                x="110"
                y="172"
                text-anchor="middle"
                font-size="16"
                font-weight="bold"
                fill="var(--brandHoverText)"
              >
                !
              </text>
              <defs>
                <radialGradient id="glowG" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stop-color="#f8c300" />
                  <stop
                    offset="100%"
                    stop-color="var(--brandHoverText)"
                    stop-opacity="0"
                  />
                </radialGradient>
                <linearGradient id="faceG" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#1a3499" />
                  <stop offset="100%" stop-color="#0a1a5c" />
                </linearGradient>
                <linearGradient id="ringG" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#f8c300" />
                  <stop offset="100%" stop-color="#ffffff" stop-opacity="0.3" />
                </linearGradient>
              </defs>
            </svg>

            <!-- Text -->
            <div class="text-center">
              <h3 class="text-[#f8c300] font-bold text-xl tracking-tight mb-1">
                Session Timed Out
              </h3>
              <p class="text-white/50 text-xs leading-relaxed max-w-[180px]">
                Your secure session has expired for your protection.
              </p>
            </div>

            <!-- Badges -->
            <div class="flex gap-2 flex-wrap justify-center">
              <div
                class="flex items-center gap-1.5 bg-[var(--whiteBG)]/10 border border-white/10 text-white/70 text-[11px] font-medium px-3 py-1.5 rounded-full"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                Secure Login
              </div>
              <div
                class="flex items-center gap-1.5 bg-[var(--whiteBG)]/10 border border-white/10 text-white/70 text-[11px] font-medium px-3 py-1.5 rounded-full"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Protected
              </div>
            </div>
          </div>
        </div>

        <!-- ── Right Message Panel ── -->
        <div
          class="flex-1 bg-[var(--whiteBG)] flex flex-col justify-center items-center text-center px-8 py-10 md:px-10"
        >
          <!-- Brand -->
          <div class="flex items-center gap-2 mb-7">
            <div
              class="w-2.5 h-2.5 rounded-full bg-[#f8c300] shadow-[0_0_0_3px_rgba(248,195,0,0.2)]"
            ></div>
            <span
              class="text-[var(--brand)] text-sm font-semibold tracking-wide"
              >IIM TRICHY</span
            >
          </div>

          <!-- Heading -->
          <div class="mb-8">
            <h2
              class="text-[var(--brand)] text-2xl font-bold tracking-tight mb-2"
            >
              Your Session Has Timed Out
            </h2>
            <p
              class="text-gray-400 text-sm leading-relaxed max-w-[280px] mx-auto"
            >
              For your security, you've been signed out. Please login again to
              continue.
            </p>
          </div>

          <!-- Login -->
          <button
            type="button"
            @click="handleLogin"
            :disabled="loading"
            class="w-full max-w-[260px] py-3.5 rounded-xl bg-gradient-to-r from-[var(--brandHoverText)] to-[#1a3aad] text-white text-sm font-semibold flex items-center justify-center gap-2.5 shadow-[0_8px_24px_color-mix(in_srgb,var(--brandHoverText)_30%,transparent)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_color-mix(in_srgb,var(--brandHoverText)_40%,transparent)] active:translate-y-0 disabled:opacity-80 disabled:cursor-not-allowed"
          >
            <svg
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
              <polyline points="10 17 15 12 10 7" />
              <line x1="15" y1="12" x2="3" y2="12" />
            </svg>
            Login
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SessionExpiry",

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    ...mapActions(["logout"]),

    async handleLogin() {
      this.loading = true;
      await this.logout();
      this.$emit("close");
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
<!-- Keyframes injected once globally -->
<style>
@keyframes cardIn {
  from {
    opacity: 0;
    transform: scale(0.88) translateY(30px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes rotateHour {
  to {
    transform: rotate(360deg);
  }
}
@keyframes sweepMin {
  0%,
  100% {
    transform: rotate(-12deg);
  }
  50% {
    transform: rotate(12deg);
  }
}
</style>
